import PropTypes from 'prop-types';
import Controls from './Controls';
import ConversationList from '../../../ConversationList';
import useSearch from '../../../../hooks/useSearch';
import './SideBar.css';

const SideBar = ({
  conversations = [],
  isCreatingConversation = false,
  setCurrentConversationId = () => {},
  selectedConversationId = null,
  onCreateConversationClick = () => {},
  onMenuToggle = () => {},
  isLoading = false,
}) => {
  const {
    searchTerm,
    setSearchTerm,
    isSearching,
    setIsSearching,
    cancelSearch,
  } = useSearch();

  const filteredConversations = conversations.filter((conversation) =>
    conversation?.title?.toLowerCase()?.includes(searchTerm.toLowerCase()) || false,
  );

  return (
    <div className="side-bar">
      <div className={`side-bar-header ${(isSearching) ? 'searching' : ''}`}>
        <Controls
          searchTerm={searchTerm}
          isSearching={isSearching}
          isCreatingConversation={isCreatingConversation}
          setIsSearching={setIsSearching}
          setSearchTerm={setSearchTerm}
          cancelSearch={cancelSearch}
          onMenuToggle={onMenuToggle}
          onCreateConversationClick={onCreateConversationClick}
        />
        {
          !isSearching && <div className="side-bar-tabs"></div>
        }
      </div>
      <div className={`conversation-list-container ${(isSearching) ? 'searching' : ''}`}>
        {
          conversations.length > 0 && (
            <ConversationList
              conversations={filteredConversations}
              selectedConversationId={selectedConversationId}
              onItemClick={setCurrentConversationId}
              isLoading={isLoading}
            />
          )
        }
        {
          conversations.length === 0 && (
            <div className="side-bar-no-conversations">
              <img
                className="side-bar-no-conversations-icon"
                src='/images/svg/speech-bubble.svg'
                alt='Speech Bubble'
              />
              <span className="side-bar-no-conversations-header">No conversations yet</span>
              <span className="side-bar-no-conversations-text">Tap the compose button to start chatting with someone new.</span>
              <button
                className="side-bar-start-chat-button"
                onClick={onCreateConversationClick}
              >
                Start Chat
              </button>
            </div>
          )
        }
      </div>
    </div>
  );
};

SideBar.propTypes = {
  conversations: PropTypes.array.isRequired,
  isCreatingConversation: PropTypes.bool,
  setCurrentConversationId: PropTypes.func,
  selectedConversationId: PropTypes.string,
  onCreateConversationClick: PropTypes.func,
  onMenuToggle: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default SideBar;
